import { Component, OnInit, HostListener } from '@angular/core';

@Component({
  selector: 'app-internal-pages',
  templateUrl: './internal-pages.component.html',
  styleUrls: [

  ]
})
export class InternalPagesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {}

  @HostListener('window:beforeunload')
  doSomething() {
    localStorage.removeItem("token");
  }
}
